import React from 'react';
import { sections } from './sections';
import { CoordinatorDashboardContext } from './context';
import { Notifications } from './DashboardNotifications';
import useFeatureFlags from 'common/hooks/useFeatureFlags';

export const DashboardContent = ({ isScripWare }: { isScripWare: boolean }) => {
    const { isEnabled } = useFeatureFlags();

    return (
        <div className="w-full flex-1">
            <CoordinatorDashboardContext.Provider value={{ isScripWare }}>
                <Notifications />
                {!isScripWare && <sections.Orders />}
                <sections.Reports />
                <sections.Participants />
                <sections.Organization isEnabled={isEnabled} />
                <sections.Payments />
                {!isScripWare && <sections.Inventory />}
                <sections.Resources />
            </CoordinatorDashboardContext.Provider>
        </div>
    );
};
